import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Contact } from "@/models/Contact";
import { formatImageUrl } from "@/common/utils";
import { assert } from "@/common/assert";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
import './BroadsideContact.scss';
export default function BroadsideContact(props) {
  var contact = props.contact;
  assert(contact, "contact falsy"); //contact is either an instanceof Contact or of type UserSimpleViewModel

  assert(contact instanceof Contact || contact.UserId, "contact is neither an instance of Contact nor User");
  var info = {};
  var avatarUrl = "";
  var unreadCount = 0;

  if (Contact.isContact(contact)) {
    info = contact.getContactInfo();
    avatarUrl = formatImageUrl(info.avatarUrl, ImageSizeTypeEnum.Thumbnail100whFill);
    unreadCount = contact.unreadMessageCount;
  } else {
    info = {
      avatarUrl: formatImageUrl(contact.AvatarUrl.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail100whFill),
      linkUrl: "",
      name: contact.RealName,
      profession: contact.Profession,
      companyId: contact.CompanyId,
      companyName: contact.CompanyName,
      companyUrl: ""
    };
  }

  return _jsxs("div", __assign({
    className: "broadside-tool-contact"
  }, {
    children: [_jsx("div", __assign({
      className: "broadside-tool-contact__avatar-contain"
    }, {
      children: _jsx("img", {
        className: "broadside-tool-contact__avatar",
        src: Contact.isContact(contact) ? avatarUrl : info.avatarUrl,
        alt: info.name
      }, void 0)
    }), void 0), _jsx("div", __assign({
      className: "broadside-tool-contact__user",
      title: info.name + " " + info.profession
    }, {
      children: _jsxs("div", __assign({
        className: "broadside-tool-contact__user-content"
      }, {
        children: [_jsx("span", __assign({
          className: "broadside-tool-contact__user-name"
        }, {
          children: info.name
        }), void 0), _jsx("span", __assign({
          className: "broadside-tool-contact__user-profession"
        }, {
          children: info.profession
        }), void 0), _jsx("span", __assign({
          className: "broadside-tool-contact__user-company",
          title: info.companyName
        }, {
          children: info.companyName
        }), void 0)]
      }), void 0)
    }), void 0), unreadCount > 0 && _jsx("span", __assign({
      className: "broadside-tool-contact__badge"
    }, {
      children: unreadCount
    }), void 0)]
  }), void 0);
}